// extracted by mini-css-extract-plugin
export default {"emptyState":"empty_state-module___emptyState___e3228536","title":"empty_state-module___title___a867ec66"};